import { useEffect } from "react";
import { reportPageView } from "../tools/analytics";

export interface PageViewTrackerProps {
	pageName: string;
}

export const PageViewTracker: React.FC<PageViewTrackerProps> = (props: PageViewTrackerProps) => {
	useEffect(() => {
		// console.log("PageViewTracker " + props.pageName);
		reportPageView(props.pageName);
	}, [props.pageName]);

	return null;
};
